import type { StateOption } from "../types/portal";

export const TRAINING_PHILOSOPHY_OPTIONS: string[] = [
  "Force Free / Pure Positive",
  "Positive Reinforcement Based (+R)",
  "Clicker / Marker Training",
  "Fear Free",
  "Science Based",
  "Relationship Based",
  "Balanced",
  "LIMA (Least Intrusive, Minimally Aversive)",
  "Traditional Training Methods",
  "Alpha / Pack Based",
  "Remote Training",
];

export const AREAS_OF_EXPERTISE_OPTIONS: string[] = [
  "Puppy",
  "Manners",
  "Behavior Modification",
  "Aggression Management \u2013 Dog to dog",
  "Aggression Management - human directed",
  "Reactivity",
  "Separation Anxiety",
  "Anxiety / Fears / Phobias",
  "Leash Walking",
  "Potty Training",
  "Rescue Rehab",
  "Service Dog",
  "Therapy Dog",
  "Protection",
  "Tracking",
  "Competition Obedience",
  "Scentwork",
  "Agility",
  "Conformation",
  "Herding",
  "Earthdog",
];

export const CREDENTIAL_OPTIONS: string[] = [
  "Formal degree",
  "Professional Dog Trainer School",
  "International Association of Canine Professionals",
  "Prong Collar Assessment",
  "CDT",
  "CDTA",
  "Certification Council of Canine Dog Trainers",
  "CPDT-KA",
  "CPDT-KSA",
  "CBCC-KA",
  "CBCC-KSA",
  "NADOI \u2013 Certified Member",
  "Puppy",
  "Novice Competition",
  "Open Competition",
  "Utility Competition",
  "Tracking",
  "Tracking Excellent",
  "Agility",
  "Agility Excellent",
  "Karen Prior Academy",
  "CDT",
  "Association of Animal Behavior Professionals",
  "CDBT",
  "Certified Fear Free",
  "Stephan Lynsay LIMA",
  "Grisha Stewart CBATI",
  "AKC Judge",
  "Fetch",
  "Farm Dog",
  "Obedience",
  "Rally",
  "Scentwork",
  "Herding",
  "Agility",
  "AKC Canine Good Citizen Evaluator",
  "Canine Fitness Instructor",
  "CCFT \u2013 list affiliation",
  "Do More With Your Dogs",
  "CRDI",
  "CCFC",
  "SDJ",
  "AACE",
  "Other sport judge",
  "Breed expert",
];

export const TIME_ZONE_OPTIONS: string[] = [
  "Pacific Time (PT)",
  "Mountain Time (MT)",
  "Central Time (CT)",
  "Eastern Time (ET)",
  "Alaska Time (AKT)",
  "Hawaii Time (HST)",
];

export const US_STATE_OPTIONS: StateOption[] = [
  { value: "AL", label: "Alabama (AL)" },
  { value: "AK", label: "Alaska (AK)" },
  { value: "AZ", label: "Arizona (AZ)" },
  { value: "AR", label: "Arkansas (AR)" },
  { value: "CA", label: "California (CA)" },
  { value: "CO", label: "Colorado (CO)" },
  { value: "CT", label: "Connecticut (CT)" },
  { value: "DE", label: "Delaware (DE)" },
  { value: "FL", label: "Florida (FL)" },
  { value: "GA", label: "Georgia (GA)" },
  { value: "HI", label: "Hawaii (HI)" },
  { value: "ID", label: "Idaho (ID)" },
  { value: "IL", label: "Illinois (IL)" },
  { value: "IN", label: "Indiana (IN)" },
  { value: "IA", label: "Iowa (IA)" },
  { value: "KS", label: "Kansas (KS)" },
  { value: "KY", label: "Kentucky (KY)" },
  { value: "LA", label: "Louisiana (LA)" },
  { value: "ME", label: "Maine (ME)" },
  { value: "MD", label: "Maryland (MD)" },
  { value: "MA", label: "Massachusetts (MA)" },
  { value: "MI", label: "Michigan (MI)" },
  { value: "MN", label: "Minnesota (MN)" },
  { value: "MS", label: "Mississippi (MS)" },
  { value: "MO", label: "Missouri (MO)" },
  { value: "MT", label: "Montana (MT)" },
  { value: "NE", label: "Nebraska (NE)" },
  { value: "NV", label: "Nevada (NV)" },
  { value: "NH", label: "New Hampshire (NH)" },
  { value: "NJ", label: "New Jersey (NJ)" },
  { value: "NM", label: "New Mexico (NM)" },
  { value: "NY", label: "New York (NY)" },
  { value: "NC", label: "North Carolina (NC)" },
  { value: "ND", label: "North Dakota (ND)" },
  { value: "OH", label: "Ohio (OH)" },
  { value: "OK", label: "Oklahoma (OK)" },
  { value: "OR", label: "Oregon (OR)" },
  { value: "PA", label: "Pennsylvania (PA)" },
  { value: "RI", label: "Rhode Island (RI)" },
  { value: "SC", label: "South Carolina (SC)" },
  { value: "SD", label: "South Dakota (SD)" },
  { value: "TN", label: "Tennessee (TN)" },
  { value: "TX", label: "Texas (TX)" },
  { value: "UT", label: "Utah (UT)" },
  { value: "VT", label: "Vermont (VT)" },
  { value: "VA", label: "Virginia (VA)" },
  { value: "WA", label: "Washington (WA)" },
  { value: "WV", label: "West Virginia (WV)" },
  { value: "WI", label: "Wisconsin (WI)" },
  { value: "WY", label: "Wyoming (WY)" },
];
